/**
 * Given a numeric value and an ordered list of category labels,
 * return `"value (label)"` if the value is a valid integer index
 * into the categories array, or `undefined` otherwise.
 */
export function resolveCategoryLabel(
  value: number,
  categories: string[],
): string | undefined {
  if (!Number.isInteger(value)) {
    return undefined;
  }

  if (value >= 0 && value < categories.length) {
    return `${String(value)} (${categories[value]})`;
  }

  return undefined;
}
